import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "kl-vat-rate-list",
  templateUrl: "./vat-rate-list.component.html",
  styleUrls: ["./vat-rate-list.component.scss"],
})
export class VatRateListComponent implements OnInit {
  @Input() tabId: string;
  @Input() modalId: string;

  constructor() {}

  ngOnInit() {}
}
